export default "__VITE_ASSET__BDzXxTVi__"